export default __webpack_public_path__ + "static/media/signet.c4fddf48.svg";